import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MyMobileImport from './mobile-import';
import LocalFileImport from './local-file-import';
import LoaderAdditionalOptions from './additional-options';

class CombinedLoader extends React.Component {

  setFiles = (passedFiles) => {
    this.files = passedFiles;
  };

  setFunctions = (functions) => {
    functions.map((func) => {
      if (typeof func == 'function') {
        this[func.name.split(' ')[1]] = func;
      }
    });
  };

  render() {
    return (
      <div
        style={{ height: this.props.height }}
        className={classNames('container combined-image-loader', {
          'd-none': !this.props.isActive,
        })}>
        <div className="row">
          <div className="col upload">
            <LocalFileImport
              service="upload"
              setFilesCallback={this.setFiles}
              setFunctions={this.setFunctions}
              {...this.props}
            />
          </div>
          <div className={classNames('vertical-line', { 'd-none': this.props.isMobile })} />
          <div className={ classNames('col mobile', { 'd-none': this.props.isMobile }) }>
            <MyMobileImport service="mobile" {...this.props} />
          </div>
        </div>
      </div>
    );
  }
}

CombinedLoader.prototype[LoaderAdditionalOptions.CLOSE_ON_FILE_SELECTION] = true;

CombinedLoader.propTypes = {
  service: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  height: PropTypes.number.isRequired,
};

export default CombinedLoader;
